import { render, staticRenderFns } from "./ViewMemberNotesModal.vue?vue&type=template&id=7623f980&scoped=true&"
import script from "./ViewMemberNotesModal.vue?vue&type=script&lang=js&"
export * from "./ViewMemberNotesModal.vue?vue&type=script&lang=js&"
import style0 from "./ViewMemberNotesModal.vue?vue&type=style&index=0&id=7623f980&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7623f980",
  null
  
)

export default component.exports